module.exports = __webpack_public_path__ + "img/bg-2.168a675a.svg";